import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '@app/users/shared/user.model';
import { NoteModel } from '@app/events/shared/note.model';
import { ResourceData } from '@app/shared/abstract/resource.data';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends AbstractEntityService<UserModel> {
  constructor(http: HttpClient) {
    super('/api/contacts', http);
  }

  createContactNote(data: any) {
    return this.http.post<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes`, data);
  }

  deleteContactNote(id: number) {
    return this.http.delete<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes/${id}`);
  }

  updateContactNote(data: any, id: number) {
    return this.http.put<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes/${id}`, data);
  }
}
